/* eslint-disable */
/*
 * One row from the lexentry table.
 */

import React, { Component } from 'react'
import LexentryField from './lexentryField'
import '../../stylesheets/lexicon.css'

/*
 * Props:
 *
 * lexentry - The lexical entry object with keys:
 *            lexentry_uuid, lexicon_uuid, graphemes, phonemes, soundslike, unigram, prob, solprobs
 *
 * showAdvanced - Boolean. If true, show advanced fields.
 *
 * onDelete - What to do when user selects delete. Function that takes the lexentry.
 *
 * onAddG2P - What to do when the user selects "Add grapheme to phoneme". Function that takes the lexentry.
 *
 * onPronAudio - What to do when the user selects "play". Function that takes the lexentry.
 *
 * updateField - Called when a field gets updated. Passed the lexentry, the field ("grapheme", "phoneme", etc),
 *               the new value, and a boolean indicating if the database should be updated.
 *
 */

class LexentryRow extends Component {
  render() {
    // Save some typing
    let lex = this.props.lexentry
    let numberRe = "[+-]?[0-9]*[.,]?[0-9]+"
    
    return (
      <tr>
	<LexentryField lexentry={lex} field="graphemes" tooltip='How the word should appear in the transcript' updateField={this.props.updateField} />
	<LexentryField lexentry={lex} field="soundslike" tooltip="What the word sounds like (letters only)" validateRe='[a-zA-Z_ -]*' updateField={this.props.updateField} />
	<td className="actionButtons">
          &nbsp;
          <span onClick={(e) => this.props.onDelete(lex)}>&times;</span>
          &nbsp;
          <span onClick={(e) => this.props.onAddG2P(lex)}>+</span>
          &nbsp;
          <span onClick={(e) => this.props.onPronAudio(lex)}>&#9658;</span>
	</td>
	<LexentryField lexentry={lex} field="phonemes" tooltip="How the word is pronounced in appropriate phonetic dictionary" updateField={this.props.updateField} />
	{ this.props.showAdvanced && <LexentryField lexentry={lex} field="unigram" tooltip="Unigram probability, log10 scale" validateRe={numberRe} updateField={this.props.updateField} /> }
	{ this.props.showAdvanced && <LexentryField lexentry={lex} field="prob" tooltip="Pronunciation probability, linear scale" validateRe={numberRe} updateField={this.props.updateField} /> }
	{ this.props.showAdvanced && <LexentryField lexentry={lex} field="silprobs" tooltip="Silence coefficients. Three floats." validateRe={`(${numberRe})( *, *| +)(${numberRe})( *, *| +)(${numberRe})`} updateField={this.props.updateField} /> }
      </tr>
    )
  }
}

export default LexentryRow

